import { useEffect, useState } from 'react'

import Api from 'services/api'
import { Dealer } from 'types/Dealer'

const useDealers = (options = {}) => {
  const [dealers, setDealers] = useState < Array < Dealer >> ([])
  const [dealersMetadata, setDealersMetadata] = useState({ filteredItemCount: 0, pageNumber: 1, pageCount: 1 })
  const [areDealersLoaded, setAreDealersLoaded] = useState(false)

  useEffect(() => {
    setDealers([])
    setDealersMetadata({})
    setAreDealersLoaded(false)

    Api.Dealers.list(options)
      .then((res) => {
        const { items, ...metadata } = res

        setDealers(items)
        setDealersMetadata(metadata)
        setAreDealersLoaded(true)
      })
      .catch(() => {
        setDealers(null)
        setDealersMetadata(null)
        setAreDealersLoaded(true)
      })
  }, [options.page, options.query]) // eslint-disable-line react-hooks/exhaustive-deps

  return { dealers, dealersMetadata, areDealersLoaded }
}

export default useDealers
